import React from 'react';

export function calcPctChange(current, previous) {
    if (!previous) return null;
    return Math.round(((current - previous) / Math.abs(previous)) * 100);
}

const upStyle = { color: '#2e7d32', fontWeight: 600 };
const downStyle = { color: '#c62828', fontWeight: 600 };
const neutralStyle = { color: '#aaa' };

export function PctChangeCell({ value, onClick, style: extraStyle }) {
    if (value == null) return <span style={neutralStyle}>–</span>;
    const baseStyle = value >= 0 ? upStyle : downStyle;
    return (
        <span style={extraStyle ? { ...baseStyle, ...extraStyle } : baseStyle} onClick={onClick}>
            {value >= 0 ? '+' : ''}{value}%
        </span>
    );
}

export function buildPctChangeColumn({ id, header = 'Pokytis %', width = 90, accessor, cellProps } = {}) {
    return {
        id: id || 'pctChange',
        Header: header,
        disableFilters: true,
        width,
        accessor,
        Cell: ({ cell: { value }, row }) => (
            <PctChangeCell
                value={value}
                {...(typeof cellProps === 'function' ? cellProps(row) : cellProps)}
            />
        ),
    };
}
